import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { managementZonesTypes } from 'constants/scripts';

import {
  aggregateManagementZoneThumbnailConfig
} from 'dataviz/config/map.js';

import VizMap from 'dataviz/VizMap';

const baseString = 'vra-management-zones-thumbnail';
const classString = classNames({
  [`${baseString}`]: true
});

const drawYourOwnClass = 'vra-management-zone-thumbnail-draw';
const generateZoneClass = `${baseString}-generate`;
const isDrawYourOwn = type => type === managementZonesTypes.FIELD_BOUNDARY;
const ManagementZonesThumbnail = ({
  config,
  type,
  zones
}) => {
  return (
    <section className={classString}>
      {zones.placeholderIcon
        ? <img className={generateZoneClass} src={zones.placeholderIcon}/>
        : <VizMap
          config={ aggregateManagementZoneThumbnailConfig(config) }
          zones={ zones }
        />}
      {isDrawYourOwn(type) && !zones.placeholderIcon
        ? <div className={drawYourOwnClass} /> : null}
    </section>
  );
};
ManagementZonesThumbnail.propTypes = {
  config: propTypes.object,
  type: propTypes.string,
  zones: propTypes.object.isRequired
};
export default ManagementZonesThumbnail;
